import React from 'react';
import Svg from '../Svg';

const IconDisc02 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM14.0967 5.24454C14.3337 4.74568 14.9302 4.53339 15.4291 4.77037C18.1296 6.05323 20 8.80719 20 12C20 12.5523 19.5523 13 19 13C18.4477 13 18 12.5523 18 12C18 9.60802 16.6003 7.54096 14.5709 6.57689C14.0721 6.33991 13.8598 5.7434 14.0967 5.24454ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12ZM5 11C5.55228 11 6 11.4477 6 12C6 14.1813 7.16348 16.0919 8.90852 17.1434C9.38156 17.4285 9.53398 18.043 9.24894 18.5161C8.9639 18.9891 8.34935 19.1415 7.87631 18.8565C5.55568 17.4582 4 14.9112 4 12C4 11.4477 4.44772 11 5 11Z"
    />
  </Svg>
);

export default IconDisc02;
